export const  onbordingtype = {
    MULEEX_3PL: '3pl',
    MULEEX_ONDEMAND: 'ondemand',
}

export const  shippingMethods = {
    T2T: 'terminal-to-terminal',
    D2D: 'door-to-door',
    T2D: 'terminal-to-door',
    D2T: 'door-to-terminal',
}